module.exports = __webpack_public_path__ + "static/media/icon_right_pop_up.ca4576a3.svg";